
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/components/expandy-section",
      function () {
        return require("private-next-pages/design-system/components/expandy-section.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/components/expandy-section"])
      });
    }
  